module.exports = __webpack_public_path__ + "img/imac.4e5939d8.jpeg";